import MeliaWidget from './MeliaWidget';
import SecondaryHotelsProvider from '../layers/providers/SecondaryHotelsProvider';
import SecondaryHotelsLayer from '../layers/SecondaryHotelsLayer';
import MeliaMainMenu from '../components/meliaMainMenu/MeliaMainMenu';
import Autocomplete from '../components/autocomplete/Autocomplete';
import GooglePlacesAutocomplete from 'components/autocomplete/providers/GoogleAutocomplete';
import HotelLocation from '../components/hotelLocation/HotelLocation';
import DirectionsMobileCTA from '../components/directionsMobileCTA/DirectionsMobileCTA';
import ListCategoriesProvider from '../components/autocomplete/providers/ListCategoriesProvider';
import hotelSummaryMobilePanel from '../components/hotelSummaryMobilePanel/hotelSummaryMobilePanel';
import MessageControl from 'components/messageControl/MessageControl';
import ListHotelsProvider from "../components/autocomplete/providers/ListHotelsProvider";


export default MeliaWidget.extend({
	validation: require('./destinationResultsDate.schema.json'),

	constructor(containerId, config, api) {
		config.directionsOriginDestinationIcons = {
			origin: 'route-point-origin.png',
			destination: 'route-point-dest.png'
		};
		MeliaWidget.prototype.constructor.call(this, containerId, config, api);
	},

	initialize() {
		MeliaWidget.prototype.initialize.call(this);
	},

	onInitialized() {
		MeliaWidget.prototype.onInitialized.call(this);
		this.initializeBaseLayer();
		this.addComponent(
			new MeliaMainMenu({
				identifier: 'main-menu',
				widget: this,
				componentClass: 'melia-main-menu-class',
				classPrefix: '.melia-main-menu-class-',
				position: 'TOP_LEFT',
				visible: true,
				properties: {
					components: {
						MainBox: {
							position: 'main-box-container',
							componentConstructorClass: 'MainBox',
							properties: {}
						},
						DirectionsBox: {
							position: 'directions-box-container',
							componentConstructorClass: 'DirectionsBox',
							componentClass: 'directions-box',
							properties: {}
						},
						JPRouteDetails: {
							position: 'route-details-container',
							componentConstructorClass: 'JPRouteDetails',
							componentClass: 'jp-route-details',
							properties: {}
						}
					}
				}
			})
		);

		this.addComponent(
			new HotelLocation({
				identifier: 'main-menu',
				widget: this,
				componentClass: 'melia-main-menu-class',
				classPrefix: '.melia-main-menu-class-',
				position: 'RIGHT_BOTTOM',
				visible: true,
				properties: {}
			})
		);

		this.addComponent(
			new MessageControl({
				identifier: `message-control${this.isMobileVersion ? '-mobile' : ''}`,
				position: 'TOP_RIGHT',
				widget: this
			})
		);

		if (this.isMobileVersion) {
			this.addMobileComponents();
		}
    },

	addMobileComponents() {
		this.addComponent(
			new DirectionsMobileCTA({
				identifier: 'directions-mobile-cta',
				widget: this,
				componentClass: 'directions-mobile-cta',
				classPrefix: 'directions-mobile-cta',
				position: 'RIGHT_BOTTOM',
				visible: true
			})
		);
	},


	registerConfigClasses(
		registerComponent,
		registerLayer,
		registerLayerProvider
	) {
		registerLayer('SecondaryHotelsLayer', SecondaryHotelsLayer);
		registerLayerProvider('SecondaryHotelsProvider', SecondaryHotelsProvider);
		Autocomplete.registerProviderClass(
			'GPlacesAutocomplete',
			GooglePlacesAutocomplete
		);
		Autocomplete.registerProviderClass(
			'ListCategoriesProvider',
			ListCategoriesProvider
		);
        Autocomplete.registerProviderClass(
            'ListHotelsProvider',
            ListHotelsProvider
        );

		registerComponent('MeliaMainMenu', MeliaMainMenu);
		registerComponent('DirectionsMobileCTA', DirectionsMobileCTA);
		registerComponent('hotelSummaryMobilePanel', hotelSummaryMobilePanel);
		registerComponent('MessageControl', MessageControl);
	},

	initializeBaseLayer() {
		this.initBaseMapLayer();
		this.addLayer(
			new SecondaryHotelsLayer({
				widget: this,
				provider: SecondaryHotelsProvider,
				id: 'SecondaryHotelsLayer',
				iconMarker: {
					default: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					},
					hover: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					},
					selected: {
						url: this.hotelsJson.alternativeHotelList.iconMarker
					}
				},
				featureId: 'id',
				minZoom: this.config.minZoom
			})
		);
		this.listenTo(this.bus, 'CLICK_ON_MARKER', marker => {
			if (marker.id && marker.layerId === 'SecondaryHotelsLayer') {
				this.getMainHotelData(marker.id).then(hotelData => {
					const hotelMobileSummaryPanel = this.customComponents[
						'hotel-summary-panel'
					];
					if (this.isMobileVersion) {
						if (hotelMobileSummaryPanel) {
							hotelMobileSummaryPanel.$el.remove();
							hotelMobileSummaryPanel.remove();
						}
						this.addComponent(
							new hotelSummaryMobilePanel({
								identifier: 'hotel-summary-panel',
								widget: this,
								componentClass: 'hotel-summary-panel',
								classPrefix: 'hotel-summary-panel',
								position: 'BOTTOM_CENTER',
								visible: true,
								properties: {
									hotelData
								}
							})
						);
					} else {
						this.bus.trigger('UPDATED_HOTEL_SELECTED_DATA', hotelData);
					}
					const closeDirBox = false;
					this.bus.trigger('directions_btn_event', closeDirBox);

				});
			}
		});
	}
});



// WEBPACK FOOTER //
// ./src/widget/DestinationResultsDate.js